export default __webpack_public_path__ + "./images/gb.a8d78e4d.png";